// extracted by mini-css-extract-plugin
module.exports = {"isHighlighted":"Date-module__isHighlighted--1ZGgp"};